import { Controller } from '@hotwired/stimulus'

export default class SectionScrollerController extends Controller {
  static targets = ['section', 'link']

  static values = {
    rootMargin: { type: String, default: '0px' },
    className: { type: String, default: 'intersecting' },
    threshold: { type: Array, default: [0] }
  }

  connect = () => {
    this.observers = []
    this.sectionTargets.forEach(section => {
      const observer = new IntersectionObserver(this.intersectionCallback,
        { threshold: this.thresholdValue, rootMargin: this.rootMarginValue })

      observer.observe(section)
      this.observers.push(observer)
    })
  }

  disconnect = () => {
    this.observers.forEach(observer => observer.disconnect())
  }

  intersectionCallback = (entries) => {
    entries.forEach(entry => {
      const link = this.linkTargets.find((link) => link.dataset.sectionName === entry.target.id)
      if (!link) return

      link.classList.toggle(this.classNameValue, entry.isIntersecting)

      if (entry.isIntersecting && !this.isLinkInViewport(link)) {
        this.scrollLinkIntoView(link)
      }
    })
  }

  scrollLinkIntoView = (element) => {
    const parent = element.parentNode
    const parentComputedStyle = window.getComputedStyle(parent, null)
    const parentBorderLeftWidth = parseInt(parentComputedStyle.getPropertyValue('border-left-width'))
    const overLeft = element.offsetLeft - parent.offsetLeft < parent.scrollLeft
    const overRight = (element.offsetLeft - parent.offsetLeft + element.clientWidth - parentBorderLeftWidth) > (parent.scrollLeft + parent.clientWidth)

    if ((overLeft || overRight)) {
      parent.scrollLeft = element.offsetLeft - parent.offsetLeft - (parent.clientWidth / 2) - parentBorderLeftWidth + (element.clientWidth / 2)
    }
  }

  scrollToSection = (event) => {
    event.preventDefault()

    const link = event.target.closest('a')
    const section = this.sectionTargets.find(section => section.id === link.dataset.sectionName)
    if (!section) return

    section.scrollIntoView({ behavior: 'smooth', block: 'start' })
  }

  isLinkInViewport = (link) => {
    const { left, width } = link.getBoundingClientRect()
    const windowWidth = window.innerWidth || document.documentElement.clientWidth

    return (left >= 0 && left < windowWidth) && (left + width >= 0 && left + width <= windowWidth)
  }
}
